/**
 * Returns the current value without modifications.
 *
 * @param {*} value - Current value.
 * @returns {*} - Same value passed as argument.
 */
export const always = (_token, value) => value;
